import { Checkbox } from "antd";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import close from "../../../../assets/img/icons/Vector copy.svg";
import useFetch from "../../../../hooks/useAxios";
import Button from "../../../shared/Button";
const BlogTimeFilter = ({ closeModal, apiGetBlog,BlogTime, setBlogTime }) => {
  const onChange = e => {
    console.log(`checked = ${e.target.checked}`);
  };
  const [BlogTimeId, setBlogTimeId] = useState([])
  const TimeInfo = [
    {
        name:"newest",
        title:"جدید ترین"
        
    },
    {
        name:"oldest",
        title:"قدیمی ترین"
        
    },
]
  
  const chooseType = (newname)=>{
   const  newType = TimeInfo.filter(j => j.name === newname);
   if(BlogTimeId.includes(newname)){
     setBlogTime(BlogTime.filter(i => i.name !== newname));
     setBlogTimeId(BlogTimeId.filter(i=>i !== newname))

  }else {
    setBlogTime(prev =>  newType);
    setBlogTimeId(newname)
  }
 
  }
  useEffect(() => {
    // for (let x of BlogTime){
    //   setBlogTimeId(prev=>[...prev,x.name])
    // }

   
  }, [])
  const handleFilter = ()=>{
    apiGetBlog.reFetch()
    closeModal()
}
  
  const removefilter = ()=>{
    setBlogTime([]);
    closeModal()
  }
  return (
    <div className="ModalBackground GuestCount">
      <div className="ModalBackground--container p-[25px]">
        <div className="flex justify-between  items-center">
          <h2 className="text-[#292D32] text-[20px] font-[700]">
            نوع اقامتگاه
          </h2>
          <button onClick={closeModal}>
            <img src={close} />
          </button>
        </div>
        <hr className="my-[20px]" />
        <div className="ModalBackground--container--body">
          {TimeInfo.map((i) =>
            <div
              className="TypeofResidence-box flex items-center gap-[6px] cursor-pointer"
              onClick={() =>chooseType(i.name)}
            >
              <div
            className={`TypeofResidence-checkbox ${
                  BlogTimeId === (i.name)
              ? "TypeofResidence-checkbox--active"
              : ""}`}
              />
              {i.title}
            </div>
          )}
        </div>
        <div className="flex gap-[12px] mt-[25px]">
          <Button varient="white" fullwidth onClick={removefilter}>
            {" "}حذف فیلتر
          </Button>
          <Button varient="primary" fullwidth onClick={handleFilter}>
            تایید دسته بندی مقالات
          </Button>
        </div>
      </div>
    </div>
  );
};


export default BlogTimeFilter